import type { ReactNode } from 'react';
import { cn } from '../lib/utils.js';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from './ui/empty.js';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  /** Primary call to action — "Create the first one", "Clear filters". */
  action?: ReactNode;
  className?: string;
}

/**
 * The blank-slate panel. Previously copy-pasted as a local `function EmptyState` into six
 * route files, which meant six places to change the spacing and no shared icon treatment.
 */
export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <Empty className={cn('border border-dashed border-border', className)}>
      <EmptyHeader>
        {icon && (
          <EmptyMedia variant="icon" aria-hidden="true">
            {icon}
          </EmptyMedia>
        )}
        <EmptyTitle>{title}</EmptyTitle>
        {description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      {action && <EmptyContent>{action}</EmptyContent>}
    </Empty>
  );
}
